(function () {
  'use strict';

  function getRecipeCards() {
    return document.querySelectorAll('.ccm-wrapper');
  }

  function removeOldGeneratorUI(card) {
    var selectors = [
      '.ccm-print-options',
      '.ccm-printWithImage',
      '.ccm-printWithoutImage',
      '.ccm-btns-wrapper',
      '#ccm-printbutton'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var nodes = card.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) nodes[j].style.display = 'none';
    }
  }

  function removeGeneratorCredit(card) {
    var nodes = card.querySelectorAll('.ccm-credit');
    for (var i = 0; i < nodes.length; i++) nodes[i].remove();

    var links = card.querySelectorAll('a[href*="recipesgenerator.com"]');
    for (var j = 0; j < links.length; j++) {
      var parent = links[j].parentElement;
      if (parent && /Created using/i.test(parent.textContent || '')) parent.remove();
      else links[j].remove();
    }
  }

  function hideOldInstagramPrompt(card) {
    var nodes = card.querySelectorAll('.ccm-instagram-credit');
    for (var i = 0; i < nodes.length; i++) nodes[i].remove();
  }

  function fixInstructionNumbering(card) {
    var lists = card.querySelectorAll('ol');
    for (var i = 0; i < lists.length; i++) {
      var items = lists[i].children;
      for (var j = 0; j < items.length; j++) {
        var li = items[j];
        var first = li.firstChild;
        while (first && first.nodeType !== 3) first = first.nextSibling;
        if (first) first.nodeValue = first.nodeValue.replace(/^\s*\d+\.\s+/, '');
      }
    }
  }

  function makePrintButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'dlux-print-recipe';
    button.setAttribute('aria-label', 'Print recipe');
    button.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9V3h12v6h1a3 3 0 0 1 3 3v5h-4v4H6v-4H2v-5a3 3 0 0 1 3-3h1Zm2-4v4h8V5H8Zm8 14v-5H8v5h8Zm2-5h2v-2a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2h2v-2h12v2Z"/></svg>' +
      '<span>Print Recipe</span>';
    return button;
  }

  function addPrintButton(card) {
    if (card.querySelector('.dlux-recipe-header')) return;

    var name = card.querySelector('.ccm-name');
    if (!name) return;

    var header = document.createElement('div');
    header.className = 'dlux-recipe-header';
    name.parentNode.insertBefore(header, name);
    header.appendChild(name);
    var button = makePrintButton();
    header.appendChild(button);
  }

  function addShareButtons(card) {
    if (card.querySelector('.dlux-recipe-share')) return;

    var share = document.createElement('div');
    share.className = 'dlux-recipe-share';
    var url = window.location.href.split('#')[0];
    var title = document.title;
    var u = encodeURIComponent(url);
    var t = encodeURIComponent(title);
    var media = '';
    var image = card.querySelector('.ccm-image img');
    if (image && image.src) media = '&media=' + encodeURIComponent(image.src);

    share.innerHTML =
      '<div class="dlux-recipe-share__prompt">' +
        '<svg class="dlux-recipe-share__instagram-mark" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.3" cy="6.7" r="1" fill="#fff" stroke="none"></circle></svg>' +
        '<div class="dlux-recipe-share__prompt-text"><strong>Did you make this recipe?</strong><span>Tag @mydlux on Instagram and hashtag #mydlux</span></div>' +
      '</div>' +
      '<div class="dlux-recipe-share__right">' +
        '<div class="dlux-recipe-share__title">Share this recipe:</div>' +
        '<div class="dlux-recipe-share__buttons">' +
          '<a class="dlux-recipe-share__button" target="_blank" rel="noopener" aria-label="Share on Pinterest" title="Share on Pinterest" href="https://pinterest.com/pin/create/button/?url=' + u + media + '&description=' + t + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-3.64 19.31c-.09-1.64-.02-3.61.41-5.49l1.07-4.52s-.27-.55-.27-1.36c0-1.27.74-2.22 1.67-2.22.79 0 1.17.59 1.17 1.3 0 .79-.5 1.97-.76 3.06-.22.91.46 1.65 1.36 1.65 1.63 0 2.89-1.72 2.89-4.2 0-2.2-1.58-3.74-3.84-3.74-2.62 0-4.16 1.96-4.16 3.99 0 .79.3 1.64.69 2.1.08.1.09.19.07.29l-.26 1.05c-.04.17-.14.21-.32.13-1.19-.56-1.94-2.31-1.94-3.72 0-3.03 2.2-5.81 6.34-5.81 3.33 0 5.92 2.37 5.92 5.54 0 3.31-2.09 5.97-4.99 5.97-.97 0-1.88-.5-2.19-1.09l-.6 2.28c-.22.83-.82 1.87-1.22 2.5.92.28 1.89.43 2.89.43A10 10 0 1 0 12 2Z"/></svg>' +
          '</a>' +
          '<a class="dlux-recipe-share__button" target="_blank" rel="noopener" aria-label="Share on Facebook" title="Share on Facebook" href="https://www.facebook.com/sharer/sharer.php?u=' + u + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 21v-8h2.7l.4-3h-3.1V8.1c0-.87.24-1.46 1.51-1.46h1.62V3.95c-.28-.04-1.24-.12-2.36-.12-2.34 0-3.94 1.43-3.94 4.06V10H7.7v3h2.63v8h3.17Z"/></svg>' +
          '</a>' +
          '<a class="dlux-recipe-share__button" target="_blank" rel="noopener" aria-label="Visit DLux on Instagram" title="Visit DLux on Instagram" href="https://www.instagram.com/mydlux/">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7.2 2h9.6A5.2 5.2 0 0 1 22 7.2v9.6a5.2 5.2 0 0 1-5.2 5.2H7.2A5.2 5.2 0 0 1 2 16.8V7.2A5.2 5.2 0 0 1 7.2 2Zm0 2A3.2 3.2 0 0 0 4 7.2v9.6A3.2 3.2 0 0 0 7.2 20h9.6a3.2 3.2 0 0 0 3.2-3.2V7.2A3.2 3.2 0 0 0 16.8 4H7.2Zm9.05 1.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"/></svg>' +
          '</a>' +
          '<button type="button" class="dlux-recipe-share__button dlux-copy-link" aria-label="Copy recipe link" title="Copy recipe link">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3.9 12a4.1 4.1 0 0 1 4.1-4.1h3v2h-3a2.1 2.1 0 1 0 0 4.2h3v2H8A4.1 4.1 0 0 1 3.9 12Zm5.1 1h6v-2H9v2Zm4-5h3a4.1 4.1 0 1 1 0 8h-3v-2h3a2.1 2.1 0 1 0 0-4.2h-3V8Z"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>';

    card.appendChild(share);
  }

  function printRecipe(card) {
    var printFrame = document.createElement('iframe');
    printFrame.setAttribute('aria-hidden', 'true');
    printFrame.style.position = 'fixed';
    printFrame.style.width = '1px';
    printFrame.style.height = '1px';
    printFrame.style.border = '0';
    printFrame.style.right = '0';
    printFrame.style.bottom = '0';
    printFrame.style.opacity = '0';
    printFrame.style.pointerEvents = 'none';
    document.body.appendChild(printFrame);

    var printWindow = printFrame.contentWindow;
    var recipe = card.cloneNode(true);
    var originalShare = card.querySelector('.dlux-recipe-share');
    var printShare = originalShare ? originalShare.cloneNode(true) : null;

    // Remove screen-only / legacy controls.
    var removeSelectors = [
      '.dlux-print-recipe', '.dlux-recipe-share', '.ccm-print-options',
      '.ccm-printWithImage', '.ccm-printWithoutImage', '.ccm-btns-wrapper',
      '#ccm-printbutton', '.ccm-credit', '.ccm-instagram-credit', '.ccm-posturl'
    ];
    for (var i = 0; i < removeSelectors.length; i++) {
      var nodes = recipe.querySelectorAll(removeSelectors[i]);
      for (var j = 0; j < nodes.length; j++) nodes[j].remove();
    }

    // The generator can add a second heading such as "How to cook ..." inside
    // the instructions. It is useful on screen but redundant in a printed recipe.
    var allHeadings = recipe.querySelectorAll('h1,h2,h3,h4,h5,h6');
    for (var h0 = 0; h0 < allHeadings.length; h0++) {
      var ht = (allHeadings[h0].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^how to cook\b/i.test(ht)) allHeadings[h0].remove();
    }

    // Recommended Products are intentionally excluded from the printable recipe.
    // They remain visible on the website; only the print/PDF copy omits them.
    var recommendedHeading = null;
    var possibleHeads = recipe.querySelectorAll('h1,h2,h3,h4,h5,h6,div,p');
    for (var h = 0; h < possibleHeads.length; h++) {
      var headingText = (possibleHeads[h].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^recommended products\s*:??$/i.test(headingText)) {
        recommendedHeading = possibleHeads[h];
        break;
      }
    }

    if (recommendedHeading) {
      var nextHeading = null;
      var heads = recipe.querySelectorAll('.ccm-head,h1,h2,h3,h4,h5,h6');
      for (var nh = 0; nh < heads.length; nh++) {
        if (heads[nh] === recommendedHeading) continue;
        if (recommendedHeading.compareDocumentPosition(heads[nh]) & Node.DOCUMENT_POSITION_FOLLOWING) {
          nextHeading = heads[nh];
          break;
        }
      }

      var node = recommendedHeading;
      while (node && node !== nextHeading) {
        var nextNode = node.nextSibling;
        if (node !== nextHeading) node.remove();
        node = nextNode;
      }
    }

    // Add a compact print-only social footer, matching the on-site DLux design.
    // This is a clone of the already-working share bar; the website share bar
    // itself is never modified.
    if (printShare) {
      // Reuse the working share links, but normalize the cloned markup for
      // the isolated print document. The live theme can apply large/default
      // SVG dimensions to these elements; those rules must never leak into
      // the print layout.
      printShare.className = 'dlux-print-share';
      var sharePrompt = printShare.querySelector('.dlux-recipe-share__prompt');
      var sharePromptText = printShare.querySelector('.dlux-recipe-share__prompt-text');
      var shareRight = printShare.querySelector('.dlux-recipe-share__right');
      var shareTitle = printShare.querySelector('.dlux-recipe-share__title');
      var shareButtons = printShare.querySelector('.dlux-recipe-share__buttons');
      if (sharePrompt) sharePrompt.className = 'dlux-print-share__prompt';
      if (sharePromptText) sharePromptText.className = 'dlux-print-share__prompt-text';
      if (shareRight) shareRight.className = 'dlux-print-share__right';
      if (shareTitle) shareTitle.className = 'dlux-print-share__title';
      if (shareButtons) shareButtons.className = 'dlux-print-share__buttons';

      var shareIcon = printShare.querySelector('.dlux-recipe-share__instagram-mark');
      if (shareIcon) {
        shareIcon.className.baseVal = 'dlux-print-share__instagram-mark';
        shareIcon.setAttribute('width', '28');
        shareIcon.setAttribute('height', '28');
      }
      var shareBtns = printShare.querySelectorAll('.dlux-recipe-share__button');
      for (var sb = 0; sb < shareBtns.length; sb++) {
        shareBtns[sb].className = shareBtns[sb].className.replace('dlux-recipe-share__button', 'dlux-print-share__button');
        var svg = shareBtns[sb].querySelector('svg');
        if (svg) {
          svg.setAttribute('width', '14');
          svg.setAttribute('height', '14');
          svg.style.width = '14px';
          svg.style.height = '14px';
          svg.style.display = 'block';
        }
      }
      recipe.appendChild(printShare);
    }

    // Hero image: preserve its natural aspect ratio and keep it contained.
    var hero = recipe.querySelector('.ccm-image');
    var heroImg = hero ? hero.querySelector('img') : null;
    if (heroImg) {
      if (heroImg.getAttribute('data-src') && !heroImg.getAttribute('src')) heroImg.setAttribute('src', heroImg.getAttribute('data-src'));
      heroImg.removeAttribute('loading');
      heroImg.removeAttribute('width');
      heroImg.removeAttribute('height');
      heroImg.removeAttribute('srcset');
      heroImg.style.width = '100%';
      heroImg.style.height = 'auto';
      heroImg.style.maxWidth = '100%';
      heroImg.style.maxHeight = '2.45in';
      heroImg.style.objectFit = 'contain';
      heroImg.style.display = 'block';
      heroImg.style.margin = '0 auto';
    }

    recipe.classList.add('dlux-print-copy');

    var html = '<!doctype html><html><head><meta charset="utf-8">' +
      '<meta name="viewport" content="width=device-width, initial-scale=1">' +
      '<title>Print Recipe - ' + escapeHtml(document.title) + '</title>' +
      '<style>' +
      '@page{size:A4;margin:.24in .28in .24in .28in}' +
      '*{box-sizing:border-box}' +
      'html,body{margin:0;padding:0;background:#fff;color:#333}' +
      'body{font-family:Arial,Helvetica,sans-serif;font-size:12.5px;line-height:1.32}' +
      '.dlux-print-copy{width:100%!important;max-width:7.18in!important;min-width:0!important;min-height:10.75in!important;margin:0 auto!important;padding:0 0 .02in!important;border:1px solid #7a3b62!important;border-radius:14px!important;box-shadow:none!important;overflow:visible!important;background:#fff!important;display:flex!important;flex-direction:column!important}' +
      '.dlux-print-copy .ccm-image{width:100%!important;height:auto!important;margin:0 0 7px!important;padding:0!important;float:none!important;overflow:visible!important;border:0!important;text-align:center!important}' +
      '.dlux-print-copy .ccm-image img{width:100%!important;height:auto!important;max-width:100%!important;max-height:3.05in!important;object-fit:cover!important;display:block!important;margin:0 auto!important;border:1px solid #7a3b62!important;border-radius:14px 14px 70px 14px!important}' +
      '.dlux-print-copy .ccm-name{position:static!important;display:block!important;margin:0 0 3px!important;padding:0 10px!important;color:#7a3b62!important;font-size:21px!important;font-weight:700!important;line-height:1.16!important;text-align:center!important}' +
      '.dlux-print-copy .ccm-info{position:static!important;display:block!important;margin:0 0 4px!important;padding:0 10px!important;font-size:10.5px!important;border:0!important}' +
      '.dlux-print-copy .ccm-time{position:static!important;padding:5px 10px!important;margin:0 0 6px!important;border-top:1px dashed #c49ab7!important;border-bottom:1px dashed #c49ab7!important;text-align:center!important;font-size:10.5px!important}' +
      '.dlux-print-copy .ccm-time-child{position:relative!important}' +
      '.dlux-print-copy .ccm-time-child:not(:last-child){margin-right:9px!important;padding-right:9px!important}' +
      '.dlux-print-copy .ccm-time-child:not(:last-child):after{content:"";position:absolute;right:0;top:50%;transform:translateY(-50%);width:1px;height:8px;background:rgba(122,59,98,.4)}' +
      '.dlux-print-copy .ccm-summary{position:static!important;font-size:10.5px!important;line-height:1.3!important;margin:5px 10px 6px!important;text-align:center!important}' +
      '.dlux-print-copy .ccm-summary:after{display:block!important;content:"";width:38px;height:1.5px;margin:6px auto 0;background:#7a3b62}' +
      '.dlux-print-copy .ccm-head{position:static!important;font-size:12px!important;line-height:1.12!important;color:#7a3b62!important;margin:6px 10px 3px!important;text-transform:uppercase!important;break-after:avoid;page-break-after:avoid}' +
      '.dlux-print-copy .ccm-section{position:static!important;font-size:11.2px!important;line-height:1.28!important;margin:0 10px 3px!important;padding-left:0!important;break-inside:auto;page-break-inside:auto}' +
      '.dlux-print-copy .ccm-section li{margin-bottom:1px!important;padding:0!important;break-inside:avoid;page-break-inside:avoid}' +
      '.dlux-print-copy .ccm-section-steps li{font-size:11.2px!important;line-height:1.24!important;margin-bottom:2px!important}' +
      '.dlux-print-copy a{color:inherit!important;text-decoration:none!important}' +
      '.dlux-print-copy .dlux-print-share{margin-top:auto!important;margin-right:0!important;margin-bottom:0!important;margin-left:0!important;display:flex!important;align-items:center!important;justify-content:space-between!important;gap:12px!important;width:100%!important;height:68px!important;min-height:68px!important;max-height:68px!important;overflow:hidden!important;padding:8px 12px!important;background:#7a3b62!important;color:#fff!important;border-radius:0 0 12px 12px!important;break-inside:avoid!important;page-break-inside:avoid!important}' +
      '.dlux-print-copy .dlux-print-share__prompt{display:flex!important;align-items:center!important;gap:8px!important;min-width:0!important}' +
      '.dlux-print-copy .dlux-print-share__prompt-text{display:block!important;color:#fff!important;font-size:8px!important;line-height:1.2!important}' +
      '.dlux-print-copy .dlux-print-share__prompt-text strong{display:block!important;font-size:9px!important;margin-bottom:2px!important}' +
      '.dlux-print-copy .dlux-print-share__prompt-text span{display:block!important;font-size:7.5px!important}' +
      '.dlux-print-copy .dlux-print-share__instagram-mark{width:28px!important;height:28px!important;max-width:28px!important;max-height:28px!important;display:block!important;fill:none!important;stroke:#fff!important;stroke-width:2!important;flex:0 0 28px!important}' +
      '.dlux-print-copy .dlux-print-share__right{display:flex!important;align-items:center!important;gap:7px!important;padding-left:10px!important;border-left:1px solid rgba(255,255,255,.65)!important}' +
      '.dlux-print-copy .dlux-print-share__title{margin:0!important;font-size:8px!important;font-weight:700!important;white-space:nowrap!important;color:#fff!important}' +
      '.dlux-print-copy .dlux-print-share__buttons{display:flex!important;align-items:center!important;gap:5px!important}' +
      '.dlux-print-copy .dlux-print-share__button{width:24px!important;height:24px!important;min-width:24px!important;min-height:24px!important;max-width:24px!important;max-height:24px!important;padding:0!important;border:1px solid rgba(255,255,255,.9)!important;border-radius:50%!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;color:#fff!important;background:rgba(255,255,255,.08)!important;text-decoration:none!important;overflow:hidden!important}' +
      '.dlux-print-copy .dlux-print-share__button svg{width:14px!important;height:14px!important;max-width:14px!important;max-height:14px!important;display:block!important;fill:currentColor!important}' +
      '.dlux-print-copy .ccm-section-steps h1,.dlux-print-copy .ccm-section-steps h2,.dlux-print-copy .ccm-section-steps h3,.dlux-print-copy .ccm-section-steps h4,.dlux-print-copy .ccm-section-steps h5,.dlux-print-copy .ccm-section-steps h6{display:none!important}' +
      '@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}.dlux-print-copy *{orphans:2;widows:2}}' +
      '</style></head><body>' + recipe.outerHTML +
      '<script>' +
      'function waitForImages(){var imgs=[].slice.call(document.images);return Promise.all(imgs.map(function(img){return img.complete?Promise.resolve():new Promise(function(r){img.onload=img.onerror=r;});}));}' +
      'window.addEventListener("load",function(){waitForImages().then(function(){setTimeout(function(){window.print();},150);});});' +
      '<\\/script></body></html>';

    var cleanedUp = false;
    function cleanupPrintFrame() {
      if (cleanedUp) return;
      cleanedUp = true;
      if (printFrame.parentNode) printFrame.parentNode.removeChild(printFrame);
    }

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();

    // Do not wait for every image before invoking print. In Shopify preview,
    // lazy-loaded images can remain incomplete and prevent the print dialog
    // from ever being called. The browser can continue loading images while
    // the print dialog is prepared.
    var printed = false;
    function invokePrint() {
      if (printed) return;
      printed = true;
      try { printWindow.focus(); } catch (e) {}
      try { printWindow.print(); } catch (e) {}
    }

    // Print as soon as the print document loads, with a short fallback for
    // browsers that do not fire load reliably on an iframe document.
    try {
      printWindow.addEventListener('load', function () {
        window.setTimeout(invokePrint, 100);
      });
    } catch (e) {}
    window.setTimeout(invokePrint, 700);

    if ('onafterprint' in printWindow) printWindow.onafterprint = cleanupPrintFrame;
    window.setTimeout(cleanupPrintFrame, 60000);
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char];
    });
  }

  function enhance() {
    var cards = getRecipeCards();
    for (var i = 0; i < cards.length; i++) {
      removeOldGeneratorUI(cards[i]);
      removeGeneratorCredit(cards[i]);
      hideOldInstagramPrompt(cards[i]);
      fixInstructionNumbering(cards[i]);
      addPrintButton(cards[i]);
      addShareButtons(cards[i]);
    }
  }

  document.addEventListener('click', function (event) {
    var el = event.target;
    while (el && el !== document) {
      if (el.classList && el.classList.contains('dlux-print-recipe')) {
        event.preventDefault();
        var card = el.closest ? el.closest('.ccm-wrapper') : null;
        if (card) printRecipe(card);
        return;
      }
      if (el.classList && el.classList.contains('dlux-copy-link')) {
        event.preventDefault();
        var link = window.location.href.split('#')[0];
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(link).then(function () {
            el.setAttribute('title', 'Link copied!');
            window.setTimeout(function () { el.setAttribute('title', 'Copy recipe link'); }, 1400);
          });
        }
        return;
      }
      el = el.parentElement;
    }
  });

  function start() {
    enhance();
    window.setTimeout(enhance, 300);
    window.setTimeout(enhance, 1000);
    window.setTimeout(enhance, 2000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
